import styles from './RichText.module.scss';

type Props = {
	className?: string;
	text?: string | null;
};

export function RichText({ text, className }: Props) {
	// eslint-disable-next-line @eslint-react/dom/no-dangerously-set-innerhtml
	return <div className={`${styles.richText} ${className ?? ''}`} dangerouslySetInnerHTML={{ __html: text || '' }} />;
}
